// Carousel with mini scrollbar and buttons below
'use client'

import { useCarousel } from '@/hooks/useCarousel'
import IconButton from './ui/IconButton'
import clsx from 'clsx'
import React from 'react'

type Props = {
	children: React.ReactNode
	className?: string
	sliderClassName?: string
	clickAndScroll?: boolean
}

export default function Carousel({ children, sliderClassName, className, clickAndScroll }: Props) {
	const { sliderContainerRef, isAtStart, isAtEnd, handleScroll, handleCardClick } = useCarousel()

	return (
		<div className={clsx('flex flex-col', className)}>
			<div
				ref={sliderContainerRef}
				className={clsx(
					'flex flex-row gap-2.5 md:gap-5 overflow-x-auto scroll-bar-mini pb-20',
					sliderClassName
				)}
			>
				{React.Children.map(children, (child, idx) => {
					if (React.isValidElement(child)) {
						return React.cloneElement(child as React.ReactElement, {
							onClick: clickAndScroll ? () => handleCardClick(idx) : undefined,
						})
					}
					return child
				})}
			</div>

			{/* Carousel Buttons */}
			<div className="flex gap-2 ml-auto common-x-padding -translate-y-1/2">
				<IconButton
					icon="Arrow"
					className="rotate-180"
					variant="outline-accent"
					aria-label="scroll to previous card"
					onClick={() => handleScroll(-1)}
					disabled={isAtStart}
				/>
				<IconButton
					icon="Arrow"
					variant="outline-accent"
					aria-label="scroll to next card"
					onClick={() => handleScroll(1)}
					disabled={isAtEnd}
				/>
			</div>
		</div>
	)
}
